import {
  GET_DASHBOARD_INFO_SUCCESS,
  GET_DASHBOARD_INFO_FAIL,
  GET_MEDIAN_AVERAGE_INFO_SUCCESS,
  GET_MEDIAN_AVERAGE_INFO_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

const INIT_STATE = {
  curInfo: [],
  pastInfo: [],
  date: [],
  period: [],
  countryStats: [],
  clientsStats: [],
  weeklyData: [],
  weeksRange: [],
  periodFrames: [],
  title: 'Last 12 weeks only',
  median: 0,
  avg: 0,
  loading: false
};

const dashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DASHBOARD_INFO_SUCCESS:
      return {
        ...state,
        date: action.payload[0],
        period: action.payload[1],
        curInfo: action.payload[2][0],
        pastInfo: action.payload[3][0],
        countryStats: action.payload[4],
        clientsStats: action.payload[5],
        weeklyData: action.payload[6],
        weeksRange: action.payload[7],
        periodFrames: action.payload[8],
        title: action.payload[9],
      };
    case GET_DASHBOARD_INFO_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case GET_MEDIAN_AVERAGE_INFO_SUCCESS:
      return {
        ...state,
        median: action.payload[0],
        avg: action.payload[1]
      };
    case GET_MEDIAN_AVERAGE_INFO_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
};

export default dashboard;
